// Environment configuration
export const USE_MOCK_DATA = process.env.REACT_APP_USE_MOCK === 'true';
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Demo mode settings
export const DEMO_MODE = USE_MOCK_DATA;
export const DEMO_CELEBRITIES = ['106033-87', '105876-55', '162886-33']; // Ashton, Jared, Gwyneth

// Feature flags
export const FEATURES = {
  LIVE_STREAMS: true, // Enabled as per newfront.md
  REWARDS: true, // Enabled as per newfront.md
  FULL_COMPANY_DATA: DEMO_MODE ? ['clay-001', 'uber-002', 'spotify-003', 'airbnb-004', 'goop-005', 'openai-006'] : true
};

// Export environment info
export const getEnvironmentInfo = () => {
  return {
    mode: USE_MOCK_DATA ? 'demo' : 'production',
    api: USE_MOCK_DATA ? 'mock' : API_BASE_URL,
    features: FEATURES
  };
};